export const GET_SUGGESTIONS = 'GET_SUGGESTIONS';
export const GET_SUGGESTIONS_SUCCESS = 'GET_SUGGESTIONS_SUCCESS';
export const GET_SUGGESTIONS_ERROR = 'GET_SUGGESTIONS_ERROR';
export const CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const SET_QUERY_STRING = 'SET_QUERY_STRING';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_NETWORK_SUGGESTIONS_LOADING = 'SET_NETWORK_SUGGESTIONS_LOADING'
